var map = {
	"./Auth/Login": 9192,
	"./Auth/Login.vue": 9192,
	"./Certificate/Index": 3861,
	"./Certificate/Index.vue": 3861,
	"./Error404": 1549,
	"./Error404.vue": 1549,
	"./Error500": 4829,
	"./Error500.vue": 4829,
	"./Inscriptions/Index": 5016,
	"./Inscriptions/Index.vue": 5016,
	"./Panel/Courses/Create": 6531,
	"./Panel/Courses/Create.vue": 6531,
	"./Panel/Index": 5387,
	"./Panel/Index.vue": 5387,
	"./Panel/Inscriptions/List": 7898,
	"./Panel/Inscriptions/List.vue": 7898
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;